import { Box, Text } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const CooldownWrapper = Box.withConfig({
  width: 'full',
  height: '54px',
  flexDirection: 'row',
  flexWrap: 'wrap',
  color: primitive.$white,
  fontSize: 'sm',
  lineHeight: '14px',
  backgroundColor: Styles.color.alert.info.background,
  padding: '6px',
  // animation: ${slideIn} 0.4s 0.15s forwards;
});

export const TextWrapper = Box.withConfig({
  justifyContent: 'space-around',
  marginLeft: '$3',
});

export const CooldownTitle = Text.withConfig({
  fontWeight: 'bold',
  color: primitive.$white,
});

export const CooldownDescription = Text.withConfig({
  fontWeight: 'bold',
  margin: 0,
  fontSize: 'xs',
  color: primitive.$white,
});
